import axios from 'axios'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function listarDispositivosStoneUsuarioLogado(empresaId) {
  const url = `${URL}/empresas/${empresaId}/stone-connect/dispositivo/usuario-logado`;
  return () => axios.get(url, SLOW_REQUEST_CONFIG);
}
